import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Button, ButtonGroup, Paper } from '@mui/material';

import AssetNameSearch from './AssetNameSearch';
import { showAllAssets, unpinAllAssets, pinnedAssetsSelector, assetViewTypeSelector, setViewType } from '../../features/assets/assetsSlice';
import { liveTrackinglayoutSelector } from '../../features/layout/layoutSlice';
import { setNeedBounding } from '../../features/map/mapSlice';


const AssetViewControl = () => {

    const dispatch = useDispatch();
    const dimentions = useSelector(liveTrackinglayoutSelector);
    const pinnedAssets = useSelector(pinnedAssetsSelector);
    const viewType = useSelector(assetViewTypeSelector);

    const [filterState, setfilterState] = useState(false);

    const showList = (type) => {
        //console.log("Filterstate", filterState, type);
        if (type === 'fullList') {
            //console.log("Showing full list");
            dispatch(setViewType("fullList"));
            dispatch(showAllAssets());
        } else if (type === 'filteredList') {
            //console.log("Shwoing filtered list");
            dispatch(setViewType("filteredList"));
        } else {
            if (filterState) {
                //console.log("Shwoing filtered list");
                dispatch(setViewType("filteredList"));
            } else {
                //console.log("Showing full list");
                dispatch(setViewType("fullList"));
                dispatch(showAllAssets());
            }
        }

    }

    const unpinAll = () => {
        dispatch(unpinAllAssets());
    }

    useEffect(() => {
        if (viewType === 'fullList') {
            //console.log("Setting viewType filter", viewType);
            setfilterState(false);
        }
        else if (viewType === 'filteredList') {
            //console.log("Setting viewType filter", viewType);
            setfilterState(true);
        }
        dispatch(setNeedBounding(true));
    }, [viewType, dispatch])

    return (
        <div style={dimentions.uppersidebar}>
            <Paper style={{ backgroundColor: 'white' }}>
                <div style={{ marginTop: '5x', marginBottom: '5px', marginLeft: '15px' }}>
                    <AssetNameSearch />
                </div>
                <div style={{ marginTop: '10px', marginBottom: '5px', marginLeft: '15px' }}>
                    {
                        viewType === 'fullList' ?
                            <ButtonGroup color="primary">
                                <Button
                                    size="small"
                                    color="primary"
                                    onClick={() => dispatch(setViewType("summary"))}

                                >
                                    Summary
                                </Button>
                                <Button
                                    size="small"
                                    color="secondary"
                                    onClick={() => dispatch(setViewType("noList"))}
                                >
                                    Hide Fleet
                                </Button>
                                {
                                    pinnedAssets.length > 0 ? <Button
                                        size="small"
                                        color="primary"
                                        onClick={unpinAll}
                                    >
                                        Unpin All
                                    </Button> : null
                                }


                            </ButtonGroup> : null
                    }

                    {
                        viewType === 'filteredList' ?
                            <ButtonGroup color="primary" style={{ marginBottom: '10px' }}>
                                <Button
                                    size="small"
                                    color="primary"
                                    onClick={() => dispatch(setViewType("summary"))}
                                >
                                    Summary
                                </Button>
                                <Button
                                    size="small"
                                    color="primary"
                                    onClick={() => showList('fullList')}
                                >
                                    Full Fleet
                                </Button>
                                <Button
                                    size="small"
                                    color="secondary"
                                    onClick={() => dispatch(setViewType("noList"))}
                                >
                                    Hide Fleet
                                </Button>
                                {
                                    pinnedAssets.length > 0 ? <Button
                                        size="small"
                                        color="primary"
                                        onClick={unpinAll}
                                    >
                                        Unpin All
                                    </Button> : null
                                }

                            </ButtonGroup> : null
                    }

                    {
                        viewType === 'summary' ?
                            <ButtonGroup color="primary">
                                <Button
                                    size="small"
                                    color="primary"
                                    onClick={showList}
                                >
                                    Show Fleet
                                </Button>
                            </ButtonGroup> : null
                    }

                    {
                        viewType === 'noList' ?
                            <ButtonGroup color="primary">
                                <Button
                                    size="small"
                                    color="primary"
                                    onClick={() => dispatch(setViewType("summary"))}
                                >
                                    Summary
                                </Button>
                                <Button
                                    size="small"
                                    color="primary"
                                    onClick={showList}
                                >
                                    Show Fleet
                                </Button>
                            </ButtonGroup> : null
                    }
                </div>
                <div style={{ height: '5px' }}></div>

            </Paper>

        </div>);
}

export default React.memo(AssetViewControl);
